import AllVideosTable from './AllVideos';

export default AllVideosTable;
